import { getAgreements } from "../../../api/agreementsApi";
import { isMyPendingAgreementStep } from "../../ProjectsV2/ProjectFinance/Agreements/agreementsListHelpers";

/** Сколько соглашений сейчас ждут решения этого согласующего. */
export const countMyPendingAgreements = async (userId) => {
  if (userId == null) return 0;

  const pageSize = 100;
  let page = 1;
  let counted = 0;
  let seen = 0;
  let total = null;

  while (page <= 100) {
    const data = await getAgreements({
      approver_id: userId,
      page,
      page_size: pageSize,
    });
    const results = Array.isArray(data?.results)
      ? data.results
      : Array.isArray(data)
        ? data
        : [];
    if (total == null) {
      const parsed = Number(data?.count);
      total = Number.isFinite(parsed) ? parsed : results.length;
    }
    counted += results.filter((item) =>
      isMyPendingAgreementStep(item, userId),
    ).length;
    seen += results.length;
    if (results.length === 0 || seen >= total || results.length < pageSize) {
      break;
    }
    page += 1;
  }

  return counted;
};
